import React, { useEffect, useState, useCallback } from 'react';
// import DataTable from '@/containers/data_table_ml/DataTable';
import DataTableNativeML from '@/components/DataTableNativeML';
import { useDispatch, useSelector } from 'dva';
import dayjs from 'dayjs';
import { bindTypeMap } from '@/constants.js';
import { useIntl } from 'umi';
import BindRecordStyled from './BindRecordStyled';
import webStorage from '@/utils/storageManager';

const BindRecord = (props) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const DICTOBJ = webStorage.get('DICTOBJ');
  const channelList = DICTOBJ.DATA_CHANNEL;
  console.log('channelList', channelList);
  const { params = {} } = props || {};
  const { id } = params || {};

  const columns = [
    // {
    //   title: formatMessage({ id: 'cm.member.detail.c01.lbl01' }),
    //   align: 'center',
    //   id: 'channel',
    //   key: 'channel',
    //   render: ({ channel }) => {
    //     return channelList.find((i) => i.dictCode === channel)?.nameZh;
    //   },
    // },
    // {
    //   title: formatMessage({ id: 'cm.member.detail.c01.lbl02' }),
    //   align: 'center',
    //   id: 'storeName',
    //   key: 'storeName',
    // },
    {
      title: formatMessage({ id: 'cm.member.detail.c01.lbl03' }),
      key: 'type',
      id: 'type',
      align: 'center',
      render: ({ type: recor }) => {
        let itemUnuse = {};
        itemUnuse = DICTOBJ.IDENTITY_TYPE.filter((item) => {
          return recor === item.dictCode;
        });
        return itemUnuse[0] && itemUnuse[0].nameZh;
      },
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c01.lbl04' }),
      align: 'center',
      id: 'changeType',
      key: 'changeType',
      // render: (text) => optionToKey(bindTypeMap, text),
      render: ({ changeType: text }) => bindTypeMap[text],
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c01.lbl05' }),
      align: 'center',
      id: 'changeDate',
      key: 'changeDate',
      render: ({ changeDate: text }) =>
        text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '--',
    },

    {
      title: formatMessage({ id: 'cm.member.detail.c01.lbl06' }),
      align: 'center',
      id: 'account',
      key: 'account',
      width: 220,
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c01.lbl07' }),
      align: 'center',
      id: 'createBy',
      key: 'createBy',
      render: ({ createBy }) => (createBy ? createBy : '--'),
    },

    // 无数据且没有业务意义, 暂时注释隐藏
    // {
    //   title: '操作来源',
    //   id: 'identitySource',
    //   key: 'identitySource',
    // },
  ];

  const dispatch = useDispatch();

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['ml/getBindRecord'];
  const datas = useSelector((state) => state.ml.getBindRecord);
  const { total, data: dataList } = datas || {};
  const [pageData, setPageData] = useState({
    pageSize: 10,
    pageNum: 1,
  });
  // const [limit, setLimit] = useState(10);
  // const [page, setPage] = useState(1);
  // 发起请求
  const setUseCallback = useCallback(() => {
    if (id) {
      dispatch({
        type: 'ml/getBindRecord',
        payload: {
          values: {
            pageSize: pageData.pagSize,
            currentPage: pageData.pageNum,
            member_id: id,
          },
        },
      });
    }
  }, [dispatch, pageData, id]);
  useEffect(() => {
    setUseCallback();
  }, [setUseCallback]);

  return (
    <BindRecordStyled>
      <DataTableNativeML
        loading={loading}
        paging={true}
        pageButton={false}
        total={total}
        // title="会员列表"
        columns={columns}
        page={{
          ...pageData,
          total: total,
        }}
        // buttonTitle={[{ text: '新增', onClick: edit }]}
        changePage={(pageObj) => {
          setPageData(pageObj);
        }}
        data={dataList}
        columnKey="id"
      ></DataTableNativeML>
    </BindRecordStyled>
    // <DataTable
    //   loading={loading}
    //   className="demo-test"
    //   columns={columns}
    //   rowSelection={false}
    //   pagination={{
    //     pageSize: limit,
    //     total: total,
    //     page: page,
    //   }}
    //   // scroll={{ y: 'calc(100vh - 150px - 3rem)' }}
    //   scroll={{ y: 'calc(100vh - 300px - 3.5rem)' }}
    //   dataSource={dataList}
    //   changePage={({ current }) => {
    //     setPage(current);
    //   }}
    //   changePageSize={(val) => {
    //     setLimit(val);
    //     setPage(1);
    //   }}
    // />
  );
};
export default BindRecord;
